export default __webpack_public_path__ + "static/media/ventas.edfaf6df.png";